import { jsx } from "react/jsx-runtime";
import { Box, Stack } from "@contember/ui";
import { memo } from "react";
const EmptyMessage = memo(({ children, component, distinction }) => {
  const MessageComponent = component ?? EmptyMessageDefault;
  return /* @__PURE__ */ jsx(MessageComponent, { distinction, children });
});
EmptyMessage.displayName = "EmptyMessage";
const EmptyMessageDefault = memo(({ children, distinction }) => /* @__PURE__ */ jsx(Box, { distinction, intent: "default", padding: "with-padding", children: /* @__PURE__ */ jsx(
  Stack,
  {
    direction: "horizontal",
    justify: "space-around",
    children
  }
) }));
export {
  EmptyMessage
};
//# sourceMappingURL=EmptyMessage.js.map
